// extracted by mini-css-extract-plugin
export default {"button":"ToolsButton_button__tV6D0","link":"ToolsButton_link__8Rg8m"};